'use strict';

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _hasInstance = require('babel-runtime/core-js/symbol/has-instance');

var _hasInstance2 = _interopRequireDefault(_hasInstance);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (global, factory) {

  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.mixwith = mod.exports;
  }
})(undefined, function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _cachedApplicationRef = exports._cachedApplicationRef = (0, _symbol2.default)('_cachedApplicationRef');

  var _mixinRef = exports._mixinRef = (0, _symbol2.default)('_mixinRef');

  var _originalMixin = exports._originalMixin = (0, _symbol2.default)('_originalMixin');

  var wrap = exports.wrap = function (mixin, wrapper) {
    (0, _setPrototypeOf2.default)(wrapper, mixin);
    if (!mixin[_originalMixin]) {
      mixin[_originalMixin] = mixin;
    }
    return wrapper;
  };

  var Cached = exports.Cached = function (mixin) {
    return wrap(mixin, function (superclass) {
      // Get or create a symbol used to look up a previous application of mixin
      // to the class. This symbol is unique per mixin definition, so a class will have N
      // applicationRefs if it has had N mixins applied to it. A mixin will have
      // exactly one _cachedApplicationRef used to store its applications.
      var applicationRef = mixin[_cachedApplicationRef];
      if (!applicationRef) {
        applicationRef = mixin[_cachedApplicationRef] = (0, _symbol2.default)(mixin.name);
      }
      // Look up an existing application of `mixin` to `c`, return it if found.
      if (superclass.hasOwnProperty(applicationRef)) {
        return superclass[applicationRef];
      }
      // Apply the mixin
      var application = mixin(superclass);
      // Cache the mixin application on the superclass
      superclass[applicationRef] = application;
      return application;
    });
  };

  var HasInstance = exports.HasInstance = function (mixin) {
    if (_hasInstance2.default && !mixin.hasOwnProperty(_hasInstance2.default)) {
      (0, _defineProperty2.default)(mixin, _hasInstance2.default, {
        value: function value(o) {
          var originalMixin = this[_originalMixin];
          while (o != null) {
            if (o.hasOwnProperty(_mixinRef) && o[_mixinRef] === originalMixin) {
              return true;
            }
            o = (0, _getPrototypeOf2.default)(o);
          }
          return false;
        }
      });
    }
    return mixin;
  };

  var BareMixin = exports.BareMixin = function (mixin) {
    return wrap(mixin, function (superclass) {
      // Apply the mixin
      var application = mixin(superclass);

      // Attach a reference from mixin applition to wrapped mixin for RTTI
      // mixin[@@hasInstance] should use this.
      application.prototype[_mixinRef] = mixin[_originalMixin];
      return application;
    });
  };

  var Mixin = exports.Mixin = function (mixin) {
    return Cached(HasInstance(BareMixin(mixin)));
  };

  var mix = exports.mix = function (superClass) {
    return new MixinBuilder(superClass);
  };

  var MixinBuilder = function () {
    function MixinBuilder(superclass) {
      (0, _classCallCheck3.default)(this, MixinBuilder);

      this.superclass = superclass;
    }

    (0, _createClass3.default)(MixinBuilder, [{
      key: 'with',
      value: function _with() {
        return (0, _from2.default)(arguments).reduce(function (c, m) {
          return m(c);
        }, this.superclass);
      }
    }]);
    return MixinBuilder;
  }();
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/mixwith/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/mixwith/index.js
// module chunks = 0